import { Component, Input, EventEmitter, OnInit } from '@angular/core';
import { BroadcastService } from '../../../core/broadcast/broadcast.service';
import { AuthService } from '../../../core/auth/auth.service';
import { Router } from '@angular/router';
import { KngActivityIndicatorService } from '@layout/kingswell/services/kngActivityIndicator.service';

@Component({
  selector: 'kng-profile',
  templateUrl: './kng-profile.component.html',
  styleUrls: ['./kng-profile.component.less']
})
export class KngProfile implements OnInit {

  @Input()
  public open: boolean = false;

  constructor(private broadcast: BroadcastService, private auth: AuthService, private router: Router, private kngActivityIndicator: KngActivityIndicatorService) {

  }

  closePanel() {
    this.open = false;
  }

  toggle() {
    this.open = ! this.open;
  }

  isOpen() {
    return this.open === true;
  }

  openPanel() {
    this.open = true;
  }

  getUser() {
    return this.auth.getAuthUser();
  }

  getName() {
    const user = this.getUser();

    if (user)
      return user.fName;
  }

  getUsername() {
    const user = this.getUser();

    if (user)
      return user.sapuid;
  }

  getInitials() {
    const user = this.getUser();

    if (user)
      return user.fName.charAt(0) + user.lName.charAt(0);
  }

  getUserRole() {
    const user = this.getUser();

    if (user) {
      return 'System Administrator';
    }
  }

  logout() {
    this.closePanel();
    this.kngActivityIndicator.show();
    this.auth.logout().then(() => {
      window.location.reload();
      this.kngActivityIndicator.close();
    });
  }

  ngOnInit() {
    this.broadcast.currentMessage.subscribe(message => {
      console.log('message', message);
      if (message === 'kng-profile.open') {
        this.open = true;
      } else if (message === 'kng-profile.close') {
        this.open = false;
      }
    });
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-profile/kng-profile.component.ts